module.exports = __webpack_public_path__ + "img/NOYA_05_H.1c863c09.jpg";